/**
 * Absorbs ghost clicks that bleed through when an overlay/modal is removed
 * or a page navigates away, and the tap lands on an element underneath.
 */
export function useGhostClickGuard() {
  function absorb(durationMs = 400) {
    const el = document.createElement('div');
    el.style.cssText = 'position:fixed;inset:0;z-index:99999;pointer-events:auto;';
    document.body.appendChild(el);
    setTimeout(() => el.remove(), durationMs);
  }

  return { absorb };
}
